import React, {useEffect} from 'react';
import * as auth from '../../api/auth';
import {logger, logout} from '../../utilities';

import {useAppStore, useColdStore} from "../../data/AppStore";
import CustomerService from '../../api/customerService';
import {shallow} from "zustand/shallow";
import {checkIsOffline} from "../../helpers/offlineHelper";
import ActionflowService from "../../api/actionflowService";

const LOG_PREFIX = '[Main.js]';

const Main = ({children}) => {

    const {COMPANY, USER, CLIENT, CART, SALE, OFFERINGS, OFFLINE, PREVIOUS_CLIENT, setOFFLINE} = useAppStore(
        (state) => ({
            COMPANY: state.COMPANY,
            USER: state.USER,
            CLIENT: state.CLIENT,
            CART: state.CART,
            SALE: state.SALE,
            OFFERINGS: state.OFFERINGS,
            OFFLINE: state.OFFLINE,
            PREVIOUS_CLIENT: state.PREVIOUS_CLIENT,
            setOFFLINE: state.setOFFLINE,
        }),
        shallow
    )
    const deleteSTORE = useAppStore.getState().deleteSTORE;
    const [getCOLDSALES, removeCOLDSALE] = useColdStore(state => [state.getCOLDSALES, state.removeCOLDSALE], shallow);

    useEffect(() => {
        if (!USER || Object.entries(USER).length === 0) {
            logout(true);
        }
    }, [USER])

    const checkAuth = () => {
        logger.debug(LOG_PREFIX, '.checkAuth()', {message: 'checking auth...'});
        if (window.location !== '/login' && window.location !== '/') {
            auth.doAuthFlow().then(() => {
                logger.debug(LOG_PREFIX, '.checkAuth()', {message: '...auth passed'});
            }).catch((error) => {
                console.log('failed to auth', error);
                logger.debug(LOG_PREFIX, '.checkAuth()', {message: `...auth failed: ${error}`});
                // logout(false, deleteSTORE());
            });
        }
    }
    const checkOffline = () => {
        checkIsOffline().then((offline) => {
            if (offline !== OFFLINE) {
                logger.debug(LOG_PREFIX, '.checkOffline()', {message: `Changing Online/Offline State. App is offline? ${offline}.`});
                setOFFLINE(offline);
            }
        });
    }
    const backgroundPushCheckouts = async () => {
        if (getCOLDSALES().length > 0) {
            logger.debug(LOG_PREFIX, '.backgroundPushCheckouts()', {message: 'Pushing checkouts to server...'});
            let completeIDs = [];
            for (const data of getCOLDSALES()) {
                debugger;
                const {user, cart, accounts, client, date} = data.sale;
                try {
                    const res = await CustomerService.saveCacheData({
                        user, cart, client, date, accounts,
                    }, (success, response) => {
                        console.log(`${success} sale`, {response});
                        if (COMPANY.actionflow) {
                            ActionflowService.makeSendCSV(COMPANY.actionflow, response)
                        }
                    })
                    console.log({res});
                    completeIDs.push(data.id);
                } catch (e) {
                    logger.error(LOG_PREFIX, '.backgroundPushCheckouts()', {message: '...failed', error: e});
                }
            }
            completeIDs.map(removeCOLDSALE);
        }
    }

    useEffect(() => {
        checkAuth();
        checkOffline();
        if (!OFFLINE) {
            backgroundPushCheckouts();
        }
    },)

    return (
        <>
            {children}
        </>
    )
}

export default Main;
